module.exports = __webpack_public_path__ + "static/media/TextToCheckInLandingScreen.d1068055.png";